jQuery(document).ready(function() {

    if(jQuery('.sidebar-arrow i').length > 0 ) {
        jQuery('.sidebar-arrow i').click(function() {
            jQuery(this).removeClass('fa-chevron-circle-right');
            jQuery(this).removeClass('fa-chevron-circle-left');
            if(jQuery(this).parent().parent().parent().parent().hasClass('clicked')) {
                jQuery(this).parent().parent().parent().parent().removeClass('clicked');
                jQuery(this).addClass('fa-chevron-circle-right');
            } else {
                jQuery(this).parent().parent().parent().parent().addClass('clicked');
                jQuery(this).addClass('fa-chevron-circle-left');
            }

        });
    }

});

jQuery('body').on('click', '.manage-sidebar-link', function(e) {
    var type = jQuery(this).attr('id');
    var data = {user_id: window.current_user, business_id: (window.business?window.business.business_id:null), type: type};
    var url = "/feedback/get-manage-sidebar-link";
    var manage_url = window.manage_server;

    jQuery.get(url, data, function(result) {

        window.open( manage_url + "/index/sso?token="+ result, '_blank');
    });
});

jQuery('body').on('click', '#more', function() {
    jQuery(this).find('i').removeClass('fa-folder');
    jQuery(this).find('i').removeClass('fa-folder-open');
    if(jQuery(this).hasClass('open')){ //close the thing
        jQuery(this).find('.text').text("More");
        jQuery(this).removeClass('open');
        jQuery(this).find('i').addClass('fa-folder');
        jQuery('body').find('.sidebar-expander').hide();
    } else { //open the thing
        jQuery(this).find('.text').text("Less");
        jQuery(this).addClass('open');
        jQuery(this).find('i').addClass('fa-folder-open');
        jQuery('body').find('.sidebar-expander').show();
    }
});

jQuery(document).ready(function() {
    if(jQuery('.sidebar-expander').find('.active').length > 0) {
        const $more = jQuery('#more');

        $more.find('.text').text("Less");
        $more.addClass('open');
        $more.find('i').addClass('fa-folder-open');
        jQuery('body').find('.sidebar-expander').show();
    }
});

// Sidebar - expandable items
function toggleVisibility(triggerSelector, contentSelector) {
    const triggers = document.querySelectorAll(triggerSelector);
    const contents = document.querySelectorAll(contentSelector);

    for (let i = 0; i < triggers.length; i++) {
        triggers[i].addEventListener('click', () => {
            contents[i].classList.toggle('d-none');

            // get the icon inside this trigger
            const icon = triggers[i].querySelector('.sidebar-icon-expand');

            if (icon) {
                const isExpanded = icon.dataset.expanded === 'true';
                icon.dataset.expanded = isExpanded ? 'false' : 'true';
            }
        });
    }
}

// Call the function for each pair
toggleVisibility('.dgb', '.dgb-container');
toggleVisibility('#ratingshistory', '.ratingshistory')
toggleVisibility('#reportsanalytics', '.reportsanalytics');
toggleVisibility('#customizationdesign', '.customizationdesign');
toggleVisibility('#toolsresources', '.toolsresources');
toggleVisibility('#settings', '.settings');
